<template>
    <div class="banner">
        <swiper :options="swiperOptiona" ref="mySwipers" class="swiper" >
            <swiper-slide class="item" v-for="(item,index) in bList" :key="index">
                <img :src="`http://www.yanbao-cheguanjia.com/${item.picurl}`" alt="">
                <div class="text">
                    <div class="cn">
                        <p>{{item.description[0]}}</p>
                        <p>{{item.description[1]}}</p>
                    </div>
                     <p class="en" v-html="item.description[2]"></p>
                    <div class="btn" @click="gotoAbout">
                        了解详情
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-pagination">

        </div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import { getProductsUrl} from '../util/lang'
    import '../common/jquery-1.11.3.min'
    export default {
        name: "banner",
        data(){
            let _this=this
            return{
                bList:[
                    {
                        description:[]
                    },
                    {
                        description:[]
                    },
                    {
                        description:[]
                    }
                ],
                swiperOptiona:{
                    pagination: {
                        el: ".banner .swiper-pagination",
                        clickable: true,
                        renderBullet: function(index, className) {
                            return '<span class="' + className + '"><i></i></span>';
                        }
                    },
                    loop: true,
                    effect: 'fade',
                    init: false,
                    autoplay:{
                        disableOnInteraction: false,
                        delay: 5000
                    },
                    on: {
                        slideChangeTransitionEnd: () => {
                            this.$nextTick(() => {
                                let swiper = _this.$refs.mySwipers.swiper;
                                let active = swiper.realIndex;
                                let previousIndex = swiper.previousIndex;
                                let bullets = swiper.pagination.bullets;
                                let bulletsArray = Array.from(bullets);
                                for (let i = 0; i < bulletsArray.length; i++) {
                                    $('.banner .swiper-pagination .swiper-pagination-bullet').eq(i).children('i').stop().width("0%")
                                }
                                for (let i = 0; i < active; i++) {
                                    $('.banner .swiper-pagination .swiper-pagination-bullet').eq(i).children('i').stop().width("100%")
                                }
                                $('.banner .swiper-pagination .swiper-pagination-bullet').eq(active).children('i').stop().animate({width: '100%'}, 5000, "linear")



                            });
                        }
                    },
                },
            }
        },
        components: {
            swiper,
            swiperSlide,
        },
        mounted(){
            setTimeout(()=>{
                this.getList('1')
            },100)
        },
        methods:{
            gotoAbout(){
                window.open('/about.html','_blank')
            },
            getList(id){
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    res.data.data.map((item)=>{
                        item.description=item.description.split('{nextpage}')
                    })
                    this.bList=res.data.data
                    setTimeout(()=>{
                        this.$refs.mySwipers.swiper.init()
                    },100)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .banner{
        width:100%;
        height:100vh;
        position: relative;
        .swiper{
            height:100%;
            .item{
                position: relative;
                overflow: hidden;
                img{
                    width:100%;
                    height:100%;
                    object-fit: cover;
                    display: block;
                    z-index: 1;
                    cursor: pointer;
                    transform: scale(1);
                    transition: all 3s;
                    filter: blur(5px);
                }
                .text{
                    z-index: 10;
                    position: absolute;
                    left: 10%;
                    top:35%;
                    width:80%;
                    color: transparent;
                     .cn{
                         p{text-align: center;}
                         p:nth-child(1){
                             font-family: "SOURCEHANSANSCN-HEAVY";
                             font-size: 26px;
                             color:white;
                             transform: rotateX(90deg);
                             transition: all 2s;
                         }
                         p:nth-child(2){
                             font-family: "SOURCEHANSANSCN-HEAVY";
                             font-size: 35px;
                             color:white;
                             transform: rotateX(90deg);
                             transition: all 2s;
                             transition-delay: 1s;
                         }
                     }
                    .en{
                        font-family: "it";
                        color:white;
                        text-align: center;
                        text-transform: uppercase;
                        line-height: 30px;
                        margin: 30px auto;
                        transform: rotateX(90deg);
                        transition: all 2s;
                        transition-delay: 2s;
                    }
                    .btn{
                        width:179px;
                        height:39px;
                        border:1px solid rgba(255,255,255,.4);
                        color:#FFFFFF;
                        text-align: center;
                        margin: 0 auto;
                        line-height: 39px;
                        cursor: pointer;
                        font-size: 14px;
                        font-family: "SOURCEHANSANSCN-LIGHT";
                        transition: all 600ms;
                        transform: rotateX(90deg);
                        z-index: 100000;
                        &:hover{
                            background-color: #286AA0;
                            color:white;
                        }
                    }
                }
            }
            .swiper-slide-active{
                img{
                    transform: scale(1.05);
                    filter: blur(0);
                }
                .text{
                   .cn{
                       p:nth-child(1), p:nth-child(2){
                           transform: rotateX(0);
                       }
                   }
                    .en{
                        transform: rotateX(0);
                    }
                    .btn{
                        transform: rotateX(0);
                    }
                }
            }
        }
        .button-prev, .button-next {
            transition: 0.5s;
            outline: none;
            position: absolute;
            width: 140px;
            z-index: 10;
            top: 50vh;
            transform: translateY(-34px);
            cursor: pointer;
            svg {
                transition: 0.5s;
            }
        }
        .button-prev {
            left: 4vw;
            #arrow-svg-home {
                transform: translateY(353px);
            }
        }
        .button-next {
            right: 4vw;
        }
        .button-next #arrow-svg-home {
            transform: translateY(353px) rotateY(180deg);
            transform-origin: 80px 0px 0px;
        }
        .cls-1 {
            transition: 0.5s;
            transform-origin: -20px 40px;
            opacity: 1;
        }
        .cls-4 {
            transition: 0.5s;
            stroke-width: 2px;
            stroke: #fff;
            fill: none;
            stroke-dasharray: 1;
            stroke-dashoffset: 1;
            opacity: 0.4;
            transform-origin: 0px 0px 0px;
        }
        #arrow-trg {
            transition: 0.5s;
            fill: #fff;
            transform: rotateY(180deg) translate(-53px, 39px);
        }
        #line {
            transition: 0.5s;
            stroke: #fff;
            transform: translate(50px, 42px);
        }
        .button:hover{
            svg{
                transform: translateX(25px);
            }
            .cls-1{
                transform: scale(1.1);
            }
            .cls-4{
                stroke-dasharray: 2px;
                stroke-dashoffset: 2px;
                opacity: 1;
            }
            #arrow-trg{
                transform: rotateY(180deg) translate(-37px, 39px);
            }
            #line{
                transform: translate(35px, 42px) scaleX(0.33);
            }
        }
        @media screen and (max-width: 1440px) and (min-width: 1000px){
            .swiper{
            }
        }
        @media screen and (max-width: 1000px){
            .swiper{
              .item{
                  .text{
                      left:5%;
                      width:90%;
                   .cn{
                       p:nth-child(1){
                           font-size: 20px;
                       }
                       p:nth-child(2){
                           font-size: 22px;
                       }
                   }
                      .en{
                          font-size: 14px;
                      }
                  }
              }
            }
        }
    }
</style>
<style scoped>
    .banner .swiper-pagination {
        bottom: 10%;
        width: 100%;
        left:0;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet {
        position: relative;
        width: 80px;
        height: 1px;
        opacity: 0.6;
        margin: 0 15px;
        background-color: rgba(255,255,255,.2);
        border-radius: 0;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet i{
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        background-color: #fff;
        opacity:1;
    }
</style>
